import { render, staticRenderFns } from "./Pop.vue?vue&type=template&id=e97135b6&scoped=true&"
import script from "./Pop.vue?vue&type=script&lang=js&"
export * from "./Pop.vue?vue&type=script&lang=js&"
import style0 from "./Pop.vue?vue&type=style&index=0&id=e97135b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97135b6",
  null
  
)

export default component.exports